"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConfirmationData = void 0;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const Types_1 = require("../../types/booking/Types");
const helpers_1 = require("../helpers");
const momentTimeAdjust = 'T12:00:00';
const getConfirmationData = (input) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
    try {
        if (!input) {
            throw new helpers_1.ContentError('Invalid parameters - input required');
        }
        if (!input.oj) {
            throw new helpers_1.OjError('Invalid parameters - OJ response required');
        }
        if (!input.content) {
            throw new helpers_1.ContentError('Invalid parameters - content required');
        }
        const { accommodations, exchangeRates: currencies, globalSettings, offers, property, taxes: propertyTaxes, termsAndConditions: terms, upsells: propertyUpsells, } = input.content;
        if (!accommodations) {
            throw new helpers_1.ContentError('Invalid parameters - content.accommodations required');
        }
        if (!globalSettings) {
            throw new helpers_1.ContentError('Invalid parameters - content.globalSettings required');
        }
        if (!offers) {
            throw new helpers_1.ContentError('Invalid parameters - content.offers required');
        }
        if (!property) {
            throw new helpers_1.ContentError('Invalid parameters - content.property required');
        }
        if (!propertyTaxes || !Array.isArray(propertyTaxes.taxes)) {
            throw new helpers_1.ContentError('Invalid parameters - content.taxes required');
        }
        if (!terms || !Array.isArray(terms)) {
            throw new helpers_1.ContentError('Invalid parameters - content.termsAndConditions array required');
        }
        const error = helpers_1.getError({
            language: input.language,
            employee: !!input.employee,
            propertyMetaData: property,
            supplierErrors: (_a = input.oj) === null || _a === void 0 ? void 0 : _a.supplierErrors,
            apiErrors: (_b = input.oj) === null || _b === void 0 ? void 0 : _b.apiErrors,
        });
        const ojResults = input.oj.results;
        if (!ojResults) {
            throw new helpers_1.OjError('Unexpected OJ Response - No Results');
        }
        if (!((_c = ojResults.hotelProducts) === null || _c === void 0 ? void 0 : _c.length)) {
            throw new helpers_1.OjError('Unexpected OJ Response - No hotelProducts');
        }
        if (!((_e = (_d = ojResults.price) === null || _d === void 0 ? void 0 : _d.total) === null || _e === void 0 ? void 0 : _e.cash)) {
            throw new helpers_1.OjError('Unexpected OJ Response - No Total Price');
        }
        const propertyName = helpers_1.formatBeverlyWilshire(property.shortName);
        let promoOffer;
        if (input.promoCode) {
            promoOffer = {
                title: '',
                urlWeb: '',
                urlApi: '',
                id: '',
                inclusionsArray: [],
                inclusions: [],
                hidden: false,
                conditions: [],
            };
        }
        const bedsByOws = accommodations.bookableAccommodations.reduce((bookableRooms, room) => {
            const bedTypes = room.sleepingArrangements.reduce((bookableBeds, bed) => {
                if (!bed.owsCode) {
                    return bookableBeds;
                }
                const bedWithName = Object.assign(Object.assign({}, bed), { uniqueName: room.uniqueName });
                return Object.assign(Object.assign({}, bookableBeds), { [bed.owsCode]: bedWithName });
            }, {});
            return Object.assign(Object.assign({}, bookableRooms), bedTypes);
        }, {});
        const rooms = [];
        let mappedTaxes = {};
        let totalRoomRate;
        const upsells = [];
        const employeeCompBooking = helpers_1.isEmployeeComplimentaryRate(input.promoCode);
        const numberOfRooms = ojResults.hotelProducts.length;
        const numberOfNights = ojResults.hotelProducts[0].duration || 0;
        let suppressPaymentOptions = true;
        let totalAdults = 0;
        let totalChildren = 0;
        let allAdvancedPurchaseOffers = true;
        const offerOrsCodes = [];
        const roomOrsCodes = [];
        let totalResortFees;
        (_f = ojResults.hotelProducts) === null || _f === void 0 ? void 0 : _f.forEach((ojRoom, roomIndex) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;
            const adults = ((_a = ojRoom.guestCount) === null || _a === void 0 ? void 0 : _a.numberAdults) || 0;
            const children = ((_b = ojRoom.guestCount) === null || _b === void 0 ? void 0 : _b.numberChildren) || 0;
            totalAdults += adults;
            totalChildren += children;
            const roomCode = ((_c = ojRoom.roomTypes) === null || _c === void 0 ? void 0 : _c.length) ? ojRoom.roomTypes[0].roomTypeId : '';
            const foundRoom = bedsByOws[roomCode];
            if (!foundRoom) {
                throw new helpers_1.OjError('Unexpected OJ Response - Room Not Found');
            }
            const offerCode = (_d = ojRoom.roomRate) === null || _d === void 0 ? void 0 : _d.ratePlanCode;
            let foundOffer;
            let ppOffer = false;
            if (input.promoCode) {
                if (input.promoCode === offerCode) {
                    const employeeRateTitle = helpers_1.getEmployeeRateTitle(input.promoCode);
                    foundOffer = Object.assign(Object.assign({}, promoOffer), { title: employeeRateTitle ||
                            helpers_1.fixPromoTitle((_e = ojRoom.roomRate) === null || _e === void 0 ? void 0 : _e.ratePlanTitle) ||
                            '' });
                }
            }
            else if (input.pp) {
                foundOffer = offers.bookableOffers.find(offer => offer.ppCode === offerCode);
                if (foundOffer) {
                    ppOffer = true;
                }
                else {
                    foundOffer = offers.bookableOffers.find(offer => offer.owsCode === offerCode);
                }
            }
            else {
                foundOffer = offers.bookableOffers.find(offer => offer.owsCode === offerCode);
            }
            if (!foundOffer) {
                throw new helpers_1.OjError('Unexpected OJ Response - Offer Not Found');
            }
            if (!foundOffer.advancePurchase || foundOffer.advancePurchase === '0') {
                allAdvancedPurchaseOffers = false;
            }
            offerOrsCodes.push(input.promoCode ? input.promoCode : foundOffer.orsCode || foundOffer.owsCode || '');
            roomOrsCodes.push(foundRoom.orsCode || foundRoom.owsCode || '');
            suppressPaymentOptions =
                suppressPaymentOptions && ((_f = ojRoom.roomRate) === null || _f === void 0 ? void 0 : _f.guaranteeType) === 'XX';
            let roomResortFees;
            const dailyRates = (_h = (_g = ojRoom.roomRate) === null || _g === void 0 ? void 0 : _g.nightlyRates) === null || _h === void 0 ? void 0 : _h.reduce((nightlyRates, nightlyRate) => {
                var _a, _b;
                if (nightlyRate.date && nightlyRate.cash) {
                    const dailyResortFees = [];
                    (_a = nightlyRate.resortFees) === null || _a === void 0 ? void 0 : _a.forEach(fee => {
                        var _a;
                        if (fee.code && fee.cash) {
                            const propertyTax = propertyTaxes.taxes.find(taxItem => taxItem.taxID === fee.code);
                            if (!employeeCompBooking || !(propertyTax === null || propertyTax === void 0 ? void 0 : propertyTax.isPercentage)) {
                                if (roomResortFees) {
                                    roomResortFees.amount += fee.cash.amount;
                                }
                                else {
                                    roomResortFees = Object.assign({}, fee.cash);
                                }
                                dailyResortFees.push({
                                    code: fee.code,
                                    description: (propertyTax === null || propertyTax === void 0 ? void 0 : propertyTax.description) || fee.description || '',
                                    price: helpers_1.convertCurrency(fee.cash, currencies, (_a = input.confirmationState) === null || _a === void 0 ? void 0 : _a.currency),
                                });
                            }
                        }
                    });
                    nightlyRates.push({
                        date: new Date(moment_timezone_1.default(nightlyRate.date + momentTimeAdjust).valueOf()),
                        price: helpers_1.convertCurrency(employeeCompBooking
                            ? helpers_1.convertEmployeePrice(nightlyRate.cash, input.promoCode)
                            : nightlyRate.cash, currencies, (_b = input.confirmationState) === null || _b === void 0 ? void 0 : _b.currency),
                        dailyResortFees,
                    });
                }
                return nightlyRates;
            }, []);
            if (!(dailyRates === null || dailyRates === void 0 ? void 0 : dailyRates.length)) {
                throw new helpers_1.OjError('Unexpected OJ Response - No Base Rate');
            }
            let roomRate = (_l = (_k = (_j = ojRoom.price) === null || _j === void 0 ? void 0 : _j.prepay) === null || _k === void 0 ? void 0 : _k.base) === null || _l === void 0 ? void 0 : _l.cash;
            let averageNightlyPrice = (_o = (_m = ojRoom.roomRate) === null || _m === void 0 ? void 0 : _m.averageNightlyPrice) === null || _o === void 0 ? void 0 : _o.cash;
            if (!roomRate) {
                throw new helpers_1.OjError('Unexpected OJ Response - No Base Rate');
            }
            if (!averageNightlyPrice) {
                throw new helpers_1.OjError('Unexpected OJ Response - No Average Nightly Price');
            }
            if (employeeCompBooking) {
                roomRate = helpers_1.convertEmployeePrice(roomRate, input.promoCode);
                averageNightlyPrice = helpers_1.convertEmployeePrice(averageNightlyPrice, input.promoCode);
            }
            if (!ojRoom.duration) {
                throw new helpers_1.OjError('Unexpected OJ Response - No Duration');
            }
            if (!totalRoomRate) {
                totalRoomRate = Object.assign({}, roomRate);
            }
            else {
                totalRoomRate.amount += roomRate.amount;
            }
            const stayResortFees = [];
            (_r = (_q = (_p = ojRoom.price) === null || _p === void 0 ? void 0 : _p.prepay) === null || _q === void 0 ? void 0 : _q.stayResortFees) === null || _r === void 0 ? void 0 : _r.forEach(fee => {
                var _a;
                if (fee.code && fee.cash) {
                    const propertyTax = propertyTaxes.taxes.find(taxItem => taxItem.taxID === fee.code);
                    if (!employeeCompBooking || !(propertyTax === null || propertyTax === void 0 ? void 0 : propertyTax.isPercentage)) {
                        if (roomResortFees) {
                            roomResortFees.amount += fee.cash.amount;
                        }
                        else {
                            roomResortFees = Object.assign({}, fee.cash);
                        }
                        stayResortFees.push({
                            code: fee.code,
                            description: (propertyTax === null || propertyTax === void 0 ? void 0 : propertyTax.description) || fee.description || '',
                            price: helpers_1.convertCurrency(fee.cash, currencies, (_a = input.confirmationState) === null || _a === void 0 ? void 0 : _a.currency),
                        });
                    }
                }
            });
            (_u = (_t = (_s = ojRoom.price) === null || _s === void 0 ? void 0 : _s.prepay) === null || _t === void 0 ? void 0 : _t.taxesFeesCharges) === null || _u === void 0 ? void 0 : _u.forEach(tax => {
                if (tax.code && tax.cash) {
                    if (!mappedTaxes[tax.code]) {
                        const propertyTax = propertyTaxes.taxes.find(taxItem => taxItem.taxID === tax.code);
                        mappedTaxes = Object.assign(Object.assign({}, mappedTaxes), { [tax.code]: {
                                description: propertyTax && propertyTax.description
                                    ? propertyTax.description
                                    : tax.description || '',
                                amount: tax.cash.amount,
                                currency: tax.cash.currencyCode,
                            } });
                    }
                    else {
                        mappedTaxes[tax.code].amount += tax.cash.amount;
                    }
                }
            });
            if (roomResortFees) {
                if (totalResortFees) {
                    totalResortFees.amount += roomResortFees.amount;
                }
                else {
                    totalResortFees = Object.assign({}, roomResortFees);
                }
            }
            const averageRate = helpers_1.convertCurrency(roomResortFees && employeeCompBooking
                ? {
                    amount: roomResortFees.amount / ojRoom.duration,
                    currencyCode: roomResortFees === null || roomResortFees === void 0 ? void 0 : roomResortFees.currencyCode,
                }
                : averageNightlyPrice, currencies, (_v = input.confirmationState) === null || _v === void 0 ? void 0 : _v.currency);
            const resortFees = roomResortFees
                ? helpers_1.convertCurrency(roomResortFees, currencies, (_w = input.confirmationState) === null || _w === void 0 ? void 0 : _w.currency)
                : undefined;
            const feesDisclaimerCheckout = resortFees && property.disclaimerTextResortFeesIncludedCheckout
                ? property.disclaimerTextResortFeesIncludedCheckout.replace('{0}', `${resortFees.currency} ${resortFees.amount.withDecimal}`.trim())
                : undefined;
            rooms.push({
                room: helpers_1.mapConfirmationDataRoomContent(foundRoom),
                offer: helpers_1.mapOfferContent(foundOffer, property, averageRate, resortFees, ppOffer, helpers_1.priceLabelAveragePerNight, false),
                averageRate,
                feesDisclaimerCheckout,
                dailyRates,
                stayResortFees,
                numberOfNights,
                adults,
                children,
            });
            if (((_y = (_x = input.oj.availabilityResults) === null || _x === void 0 ? void 0 : _x.hotelOptions) === null || _y === void 0 ? void 0 : _y.length) &&
                offerCode &&
                propertyUpsells &&
                propertyUpsells.upsells &&
                !input.pp &&
                !input.employee &&
                !((_z = input.confirmationState) === null || _z === void 0 ? void 0 : _z.upsellsHandled)) {
                const upsell = getRoomUpsell(roomIndex, offerCode, roomCode, input.oj.availabilityResults, propertyUpsells, currencies, (_0 = input.confirmationState) === null || _0 === void 0 ? void 0 : _0.currency);
                if (upsell) {
                    upsells.push(upsell);
                }
            }
        });
        if (!rooms.length || !totalRoomRate) {
            throw new helpers_1.OjError('Unexpected OJ Response');
        }
        const taxes = [];
        const employeeEstimatedTotal = {
            amount: 0,
            currencyCode: ojResults.price.total.cash.currencyCode,
        };
        propertyTaxes.taxes
            .filter(propertyTax => !employeeCompBooking || !propertyTax.isPercentage)
            .forEach(propertyTax => {
            var _a;
            if (propertyTax.taxID && mappedTaxes[propertyTax.taxID]) {
                taxes.push({
                    description: mappedTaxes[propertyTax.taxID].description,
                    price: helpers_1.convertCurrency({
                        amount: mappedTaxes[propertyTax.taxID].amount,
                        currencyCode: mappedTaxes[propertyTax.taxID].currency,
                    }, currencies, (_a = input.confirmationState) === null || _a === void 0 ? void 0 : _a.currency),
                });
                employeeEstimatedTotal.amount += mappedTaxes[propertyTax.taxID].amount;
            }
        });
        Object.keys(mappedTaxes).forEach(key => {
            var _a;
            const value = mappedTaxes[key];
            const propertyTax = propertyTaxes.taxes.find(taxItem => taxItem.taxID === key);
            if (value && !propertyTax) {
                taxes.push({
                    description: value.description,
                    price: helpers_1.convertCurrency({ amount: value.amount, currencyCode: value.currency }, currencies, (_a = input.confirmationState) === null || _a === void 0 ? void 0 : _a.currency),
                });
                employeeEstimatedTotal.amount += value.amount;
            }
        });
        if (employeeCompBooking && totalResortFees) {
            totalRoomRate.amount = totalResortFees.amount;
            employeeEstimatedTotal.amount += totalResortFees.amount;
        }
        const convertedTotalRoomRate = helpers_1.convertCurrency(employeeCompBooking || !((_g = ojResults.hotelProductsRoomRatesTotal) === null || _g === void 0 ? void 0 : _g.cash)
            ? totalRoomRate
            : ojResults.hotelProductsRoomRatesTotal.cash, currencies, (_h = input.confirmationState) === null || _h === void 0 ? void 0 : _h.currency);
        const estimatedTotal = helpers_1.convertCurrency(employeeCompBooking ? employeeEstimatedTotal : ojResults.price.total.cash, currencies, (_j = input.confirmationState) === null || _j === void 0 ? void 0 : _j.currency);
        const confirmationData = {
            propertyName,
            rooms,
            totalRoomRate: convertedTotalRoomRate,
            taxes,
            estimatedTotal,
            disclaimer: helpers_1.formatBeverlyWilshire(property.estimatedTotalDisclaimer),
            webChat: {
                enabled: false,
            },
            upsells,
            bookingTypesAllowed: [],
            suppressPaymentOptions,
            supportedCreditCards: [],
            termsAndConditions: [],
            cancelBy: input.employee ? undefined : helpers_1.getCancelByDate(terms, property.timeZone),
            labels: {
                yourReservation: helpers_1.setDictionaryKey('Your Reservation'),
                confirmYourStay: helpers_1.setDictionaryKey('Confirm Your Stay'),
                travelAgentDetails: helpers_1.setDictionaryKey('Travel agent details'),
                travelAgentId: helpers_1.setDictionaryKey('Travel Agent ID'),
                emailAddress: helpers_1.setDictionaryKey('Email Address'),
            },
            numberOfNights,
            numberOfRooms,
            totalAdults,
            totalChildren,
        };
        confirmationData.webChat = { enabled: false };
        if (property.webChatConfig) {
            const webChat = ((_k = property.webChatConfig['chatinrbf-bookingflow__step-3']) === null || _k === void 0 ? void 0 : _k.enabled) ? property.webChatConfig['chatinrbf-bookingflow__step-3']
                : property.webChatConfig['chatinrbf-bookingflow'];
            if (webChat && webChat.enabled) {
                confirmationData.webChat = {
                    enabled: webChat.enabled && !input.employee && !input.pp,
                    id: webChat.id,
                    integrationId: webChat.integrationId,
                    propertyName: property.landingPagePropertyName,
                    propertyCode: property.owsCode,
                };
                if ((_m = (_l = property.upcomingTrip) === null || _l === void 0 ? void 0 : _l.desktopImage) === null || _m === void 0 ? void 0 : _m.croppedPath) {
                    confirmationData.webChat.propertyImage = {
                        path: (_p = (_o = property.upcomingTrip) === null || _o === void 0 ? void 0 : _o.desktopImage) === null || _p === void 0 ? void 0 : _p.croppedPath,
                    };
                }
            }
        }
        if (input.pp) {
            confirmationData.bookingTypesAllowed.push(Types_1.Common.BookingType.agent);
            confirmationData.labels.yourReservation = helpers_1.setDictionaryKey('Reservation');
            confirmationData.labels.confirmYourStay = helpers_1.setDictionaryKey("Confirm Your Client's Stay");
            confirmationData.labels.travelAgentDetails = helpers_1.setDictionaryKey('Travel advisor details');
            confirmationData.labels.travelAgentId = helpers_1.setDictionaryKey('IATA Number');
            confirmationData.labels.emailAddress = helpers_1.setDictionaryKey('Guest Email Address');
        }
        else if (input.employee) {
            confirmationData.bookingTypesAllowed.push(Types_1.Common.BookingType.guest);
        }
        else {
            confirmationData.bookingTypesAllowed.push(Types_1.Common.BookingType.guest);
            confirmationData.bookingTypesAllowed.push(Types_1.Common.BookingType.booker);
            confirmationData.bookingTypesAllowed.push(Types_1.Common.BookingType.agent);
        }
        let supportsAlipay = false;
        (_q = property.supportedCreditCards) === null || _q === void 0 ? void 0 : _q.forEach(card => {
            if (card.id === 'alipay') {
                supportsAlipay = true;
            }
            else if (card.id !== 'unionpay' || globalSettings.acceptUnionPay === 'Yes') {
                confirmationData.supportedCreditCards.push({
                    path: card.icon,
                    alt: card.title,
                });
            }
        });
        if (input.employee && terms.length === 1 && ((_r = terms[0].employeeTerms) === null || _r === void 0 ? void 0 : _r.length)) {
            confirmationData.termsAndConditions = terms[0].employeeTerms.reduce((termsList, term) => {
                if (term.description) {
                    termsList.push({
                        text: term.description || '',
                        checkbox: term.agreeCheckBox,
                    });
                }
                return termsList;
            }, []);
        }
        if (!confirmationData.termsAndConditions.length) {
            const uniquePolicies = Array.from(new Set(terms.map(term => term.cancellationPolicy)));
            if (uniquePolicies.length > 1) {
                confirmationData.termsAndConditions = terms.reduce((termsList, term) => {
                    const roomOffer = termsList.push({
                        roomOffer: term.roomName && term.offerName
                            ? `${term.roomName} / ${term.offerName}`
                            : term.roomName || term.offerName,
                        text: helpers_1.formatBeverlyWilshire(term.cancellationPolicy),
                        checkbox: false,
                    });
                    return termsList;
                }, []);
            }
            else {
                confirmationData.termsAndConditions.push({
                    text: helpers_1.formatBeverlyWilshire((_s = terms[0]) === null || _s === void 0 ? void 0 : _s.cancellationPolicy),
                    checkbox: false,
                });
            }
        }
        if (!input.pp && !input.employee && property.globalTollFreeLink) {
            confirmationData.tollFreeNumbers = {
                url: property.globalTollFreeLink,
                textDictKey: helpers_1.setDictionaryKey('Toll Free Numbers By Country'),
            };
        }
        const webUrlEn = property.urlWeb
            ? property.urlWeb.replace(/\/([a-z_]{2}(_[a-z]{2,4})?)\//, '/en/')
            : '';
        if (input.pp) {
            confirmationData.contactUs = {
                url: '/contact/property_key_contacts/',
                textDictKey: helpers_1.setDictionaryKey('Contact Us'),
            };
        }
        else if (webUrlEn) {
            confirmationData.contactUs = {
                url: `${webUrlEn}/contact-us/`,
                textDictKey: helpers_1.setDictionaryKey('Contact Us'),
            };
        }
        if (property.alipayEnable &&
            property.alipayAppID &&
            supportsAlipay &&
            ojResults.price.total.cash.currencyCode === 'CNY' &&
            !suppressPaymentOptions) {
            let enabledForOffer = false;
            if (property.alipayEnabledFor === 'All Offers') {
                enabledForOffer = true;
            }
            else if (allAdvancedPurchaseOffers &&
                terms.reduce((noCancel, term) => (noCancel ? !term.cancellationBy : noCancel), true)) {
                enabledForOffer = true;
            }
            if (enabledForOffer) {
                confirmationData.alipay = {
                    paymentOptionParams: {
                        hotelCode: property.owsCode || '',
                        appId: property.alipayAppID,
                        sellerId: property.alipaySellerID,
                        storeId: property.alipayStoreID,
                        totalAmount: ojResults.price.total.cash.amount,
                        propertyTypeName: property.typeName || '',
                        propertyShortName: property.shortName || '',
                        checkInDate: ojResults.startDate || '',
                        nights: `${numberOfNights}`,
                        offerOrsCodes,
                        roomOrsCodes,
                    },
                    confirmation: {
                        title: property.alipayConfirmationTitle,
                        message: property.alipayConfirmationMessage,
                        cancelText: property.alipayCancelButtonText,
                        confirmText: property.alipayConfirmButtonText,
                    },
                };
            }
        }
        if (error.messageDictKey.key) {
            confirmationData.bookingError = {
                labelDictKey: error.labelDictKey,
                messageDictKey: error.messageDictKey,
                descriptionDictKey: error.descriptionDictKey,
                contactReservations: error.contactReservations,
                field: error.field,
            };
        }
        return confirmationData;
    }
    catch (err) {
        if (err instanceof helpers_1.ContentError || err instanceof helpers_1.OjError) {
            return { error: err };
        }
        throw err;
    }
};
exports.getConfirmationData = getConfirmationData;
const getRoomUpsell = (roomIndex, offerCode, roomCode, availabilityResults, propertyUpsells, currencies, selectedCurrency) => {
    let roomUpsell;
    if (!availabilityResults.hotelOptions[0].duration) {
        return roomUpsell;
    }
    const { roomRates } = availabilityResults.hotelOptions[0];
    const upsellPath = propertyUpsells.upsells.find(upsell => upsell.sourceAccommodationCode === roomCode);
    if (!upsellPath || !upsellPath.description || !upsellPath.upsellAccommodationTitle) {
        return roomUpsell;
    }
    const sourceRoomRateId = `.${offerCode}.${roomCode}.${roomIndex + 1}`;
    const sourcePrice = roomRates === null || roomRates === void 0 ? void 0 : roomRates.reduce((roomPrice, roomRate) => {
        var _a;
        if (!roomPrice) {
            if (roomRate.roomRateId.endsWith(sourceRoomRateId) && ((_a = roomRate.prices) === null || _a === void 0 ? void 0 : _a.length) &&
                roomRate.prices[0].total.cash) {
                return roomRate.prices[0].total.cash;
            }
        }
        return roomPrice;
    }, undefined);
    if (!sourcePrice || !sourcePrice.amount || !sourcePrice.currencyCode) {
        return roomUpsell;
    }
    const upsellRoomRateId = `.${offerCode}.${upsellPath.upsellAccommodationCode}.${roomIndex + 1}`;
    const upsellPrice = roomRates === null || roomRates === void 0 ? void 0 : roomRates.reduce((roomPrice, roomRate) => {
        var _a;
        if (!roomPrice) {
            if (roomRate.roomRateId.endsWith(upsellRoomRateId) && ((_a = roomRate.prices) === null || _a === void 0 ? void 0 : _a.length) &&
                roomRate.prices[0].total.cash) {
                return roomRate.prices[0].total.cash;
            }
        }
        return roomPrice;
    }, undefined);
    if (!upsellPrice || !upsellPrice.amount || !upsellPrice.currencyCode) {
        return roomUpsell;
    }
    if (sourcePrice.currencyCode !== upsellPrice.currencyCode) {
        return roomUpsell;
    }
    const priceDiff = (upsellPrice.amount - sourcePrice.amount) / availabilityResults.hotelOptions[0].duration;
    if (priceDiff > 0) {
        return {
            roomIndex,
            roomName: upsellPath.upsellAccommodationTitle,
            image: upsellPath.upsellImagePath ? { path: upsellPath.upsellImagePath } : undefined,
            description: helpers_1.formatBeverlyWilshire(upsellPath.description),
            price: helpers_1.convertCurrency({ amount: priceDiff, currencyCode: sourcePrice.currencyCode }, currencies, selectedCurrency),
        };
    }
    return roomUpsell;
};
